import styled from "styled-components";
import { LogoStyles } from "../../types/styles/LogoStyles";
import { useTranslation } from "react-i18next";

const StyledLogoIcon = styled.div<{ styles: LogoStyles }>`
  display: flex;
  justify-content: center;
  align-items: center;

  > img {
    background-color: ${({ styles }) =>
      styles.OverallResDiaryLogo === 2 ? "black" : "white"};
    border-radius: ${({ styles }) => `${styles.BookingSummaryBorderRadius}px`};
    padding: 0 5px;
  }
`;

const ResDiaryLogoImage = styled.img`
  min-height: 30px;
`;

export type LogoProps = {
  styles: LogoStyles;
};

const logos = {
  white:
    "https://resdiary.blob.core.windows.net/widgetthemes/newwidgetlogo3.svg",
  black:
    "https://resdiary.blob.core.windows.net/widgetthemes/newwidgetlogo2.svg",
};

const Logo: React.FC<LogoProps> = ({ styles }) => {
  const { t } = useTranslation();
  return (
    <StyledLogoIcon styles={styles} data-id="resdiary-logo-container">
      {styles.OverallResDiaryLogo !== 0 && (
        <ResDiaryLogoImage
          src={styles.OverallResDiaryLogo === 2 ? logos.black : logos.white}
          alt={t("ResDiaryLogo")}
          data-id="resdiary-logo"
        />
      )}
    </StyledLogoIcon>
  );
};

export default Logo;
